/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Czech
export default {
  'company-hub.hub-element-placeholder.config-panel.title': 'Prvky',
  'company-hub.hub-element-placeholder.extension.lozenge-updated': 'Aktualizováno',
  'company-hub.hub-element-placeholder.extension.new-lozenge': 'Nové',
  'company-hub.hub-element-placeholder.extension.sub-heading': 'Zatím tu nic není. Představte si ty možnosti…',
  'company-hub.hub-element-placeholder.extension.view-all-options': 'Zobrazit všechny možnosti',
  'company-hub.hub-element-placeholder.manifest.extension-title': 'Zástupný prvek centra',
};
